import React from "react"
import { Modal } from "@mimber/ui-web"
import { AssignTierToMemberForm } from "@/components/forms/AssignTierToMemberForm"
import type { AssignTierToMemberModalProps } from "./AssignTierToMemberModal.types"

export const AssignTierToMemberModal: React.FunctionComponent<
  AssignTierToMemberModalProps
> = ({ memberUuid, currentTierUuid, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Assign Membership Tier" {...modalProps}>
      {(close) => (
        <AssignTierToMemberForm
          memberUuid={memberUuid}
          currentTierUuid={currentTierUuid}
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
